import { Controller } from '@hotwired/stimulus'
import '../../../css/log/log.scss'
import 'jquery-ui/ui/widgets/sortable'
import 'semantic-ui-checkbox/checkbox.min'
import '../../entrypoints/modules/semantic-ui-dropdown'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css'

global.moment = require('moment')
require('tempusdominus-bootstrap-4')
$.fn.datetimepicker.Constructor.Default = $.extend(
  {},
  $.fn.datetimepicker.Constructor.Default,
  {
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'far fa-arrow-up',
      down: 'far fa-arrow-down',
      previous: 'far fa-chevron-left',
      next: 'far fa-chevron-right',
      today: 'far fa-calendar-check-o',
      clear: 'far fa-trash',
      close: 'far fa-check'
    }
  }
)

export default class extends Controller {
  static values = {
    entityType: String,
    markerCount: Number,
    selectedMarkers: Array
  }

  static targets = [
    'eventMarkers',
    'markerTemplate',
    'logEventDropdown',
    'logRelativeEventDropdown'
  ]

  connect () {
    if (this.entityTypeValue === 'logTemplate') {
      $(this.eventMarkersTarget).sortable({
        handle: '.handle'
      })
    } else if (this.entityTypeValue === 'log') {
      // Don't auto-sort on connect as it causes layout shifts during initialization
      // this.reorderMarkers()
    }

    this.initialiseExistingDropdowns()
  }

  initialiseExistingDropdowns () {
    const selectedIds = this.logEventDropdownTargets
      .map((dropdown) => $(dropdown).dropdown('get value'))
      .filter((id) => id !== '')

    selectedIds.forEach((id) => {
      this.disableEventDropdownOptions(id)
      this.removeSelfFromRelatedEventDropdowns(id)
    })
  }

  add (event) {
    if (event) event.preventDefault()

    const newMarkerRow = this.markerTemplateTarget.cloneNode(true)

    // Clean up Stimulus target attributes from the template wrapper
    newMarkerRow.removeAttribute('data-log-timings-target')

    newMarkerRow.classList.add('marker-row')
    newMarkerRow.classList.remove('d-none')

    // Generate Unique ID for the new DateTimePicker
    // Using a timestamp ensures uniqueness even if markerCountValue gets out of sync
    const timestamp = new Date().getTime()
    const newId = `datetimepicker-day-${this.element.dataset.day || '0'}-marker-${this.markerCountValue}-${timestamp}`
    newMarkerRow.dataset.logMarkerId = `new-log-marker-${this.markerCountValue}-${timestamp}`

    const absoluteTimeInputContainer =
      newMarkerRow.querySelector('.datetimepicker')

    if (absoluteTimeInputContainer) {
      absoluteTimeInputContainer.setAttribute('id', newId)

      // Update all children (input and icon-div) to point to this new ID
      Array.from(absoluteTimeInputContainer.children).forEach((child) => {
        child.setAttribute('data-target', '#' + newId)
      })
    }

    this.eventMarkersTarget.appendChild(newMarkerRow)
    this.markerCountValue += 1
  }

  enableEventDropdownOptions (markerId) {
    this.logEventDropdownTargets.forEach((dropdown) => {
      dropdown.querySelectorAll('.menu .item').forEach((option) => {
        if (option.dataset.value === markerId) {
          option.classList.remove('disabled')
        }
      })
    })
  }

  disableEventDropdownOptions (markerId) {
    this.logEventDropdownTargets.forEach((dropdown) => {
      const markerRow = dropdown.closest('.row')
      // Don't disable the option in the dropdown of the row that currently selected it
      if (markerRow && markerRow.dataset.markerId === markerId) {
        return
      }

      dropdown.querySelectorAll('.menu .item').forEach((option) => {
        if (option.dataset.value === markerId) {
          option.classList.add('disabled')
        }
      })
    })
  }

  addToRelatedEventDropdowns (markerId, newItem) {
    this.logRelativeEventDropdownTargets.forEach((dropdown) => {
      const markerRow = dropdown.closest('.row')
      if (markerRow && markerRow.dataset.markerId === markerId) {
        return
      }

      if (!dropdown.querySelector(`.menu .item[data-value="${markerId}"]`)) {
        dropdown
          .querySelector('.menu')
          .insertAdjacentHTML('beforeend', newItem)
        $(dropdown).dropdown('refresh')
      }
    })
  }

  removeFromRelatedEventDropdowns (markerId) {
    this.logRelativeEventDropdownTargets.forEach((dropdown) => {
      dropdown.querySelectorAll('.item').forEach((option) => {
        if (option.dataset.value === markerId) {
          option.remove()
          $(dropdown).dropdown('refresh')
        }
      })
    })
  }

  removeSelfFromRelatedEventDropdowns (markerId) {
    const dropdown = this.logRelativeEventDropdownTargets.find((dd) => {
      const markerRow = dd.closest('.row')
      return markerRow && markerRow.dataset.markerId === markerId
    })

    if (!dropdown) {
      return
    }
    dropdown.querySelectorAll('.item').forEach((option) => {
      if (option.dataset.value === markerId) {
        option.remove()
        $(dropdown).dropdown('refresh')
      }
    })
  }

  clearRelatedEventDropdowns (markerId) {
    this.logRelativeEventDropdownTargets.forEach((dropdown) => {
      const relativeMarkerId = $(dropdown).dropdown('get value')
      if (relativeMarkerId === markerId) {
        $(dropdown).dropdown('clear')
      }

      dropdown.querySelectorAll('.menu .item').forEach((item) => {
        if (item.dataset.value === markerId) {
          item.remove()
        }
      })
    })
  }

  getAbsoluteTimeInMinutes (absoluteMarkerId) {
    const absoluteMarker = document.querySelector(
      `.marker-row[data-marker-id="${absoluteMarkerId}"]`
    )
    if (absoluteMarker) {
      const occursAtInMinutes = parseInt(
        absoluteMarker.dataset.occursAtInMinutes
      )
      return isNaN(occursAtInMinutes) ? null : occursAtInMinutes
    }

    return null
  }

  /**
   * Calculates occurrence times for all rows.
   * @param {boolean} reorder - If true (default), sorts the rows visually.
   * Pass false if the user is currently interacting with an input
   * that shouldn't be moved (e.g., active datetimepicker).
   */
  calculateAllOccursAt (reorder = true) {
    Array.from(this.eventMarkersTarget.children).forEach(eventMarkerRow => {
      const controller = this.application.getControllerForElementAndIdentifier(eventMarkerRow, 'log-marker')
      if (controller) {
        controller.calculateOccursAt()
      }
    })

    if (reorder) {
      this.reorderMarkers()
    }
  }

  reorderMarkers () {
    if (this.entityTypeValue === 'logTemplate') {
      return
    }

    const rows = Array.from(this.eventMarkersTarget.getElementsByClassName('row'))

    rows.sort((a, b) => {
      const timeA = parseInt(a.dataset.occursAtInMinutes) || 999999
      const timeB = parseInt(b.dataset.occursAtInMinutes) || 999999
      return timeA - timeB
    })

    rows.forEach((row) => this.eventMarkersTarget.appendChild(row))
  }
}
